import { ModelStatus, TagPrefix } from '../enums/machine-models.enums';
import { BallType } from '../enums/machine.enums';
import { IGatherShotDataQuery } from '../interfaces/modelling/i-gather-shot-data';
import { IMachineModel } from '../interfaces/modelling/i-machine-model';

export const DEFAULT_MIN_GROUPS = 20;
export const DEFAULT_MAX_GROUPS = 300;
export const DEFAULT_RECORD_LIMIT = 8000;

export class ModelHelper {
  static getStatus = (model: Partial<IMachineModel>): ModelStatus => {
    if (model.status) {
      return model.status;
    }

    const result = (model.tags ?? [])
      .find((t) => t.startsWith(`${TagPrefix.Status}:`))
      ?.split(':')[1] as ModelStatus;

    return result ?? ModelStatus.Unknown;
  };

  // ! deprecate if not used
  static getBallType = (model: Partial<IMachineModel>): BallType => {
    if (model.ball_type) {
      return model.ball_type;
    }

    const result = (model.tags ?? [])
      .find((t) => t.startsWith(`${TagPrefix.BallType}:`))
      ?.split(':')[1] as BallType;

    return result;
  };

  // todo: could probably deprecate this once we have some scripts to repair all the models in the db
  static getNonSpecialTags = (tags?: string[]) => {
    return (tags ?? [])
      .filter((t) => !t.startsWith(`${TagPrefix.Status}:`))
      .filter((t) => !t.startsWith(`${TagPrefix.BallType}:`));
  };

  static getDefaultDataFilter = (
    start: Date,
    end: Date
  ): IGatherShotDataQuery => ({
    ball_type: BallType.MLB,
    start_date: start.toISOString(),
    end_date: end.toISOString(),
    min_groups: DEFAULT_MIN_GROUPS,
    max_groups: DEFAULT_MAX_GROUPS,
    limit: DEFAULT_RECORD_LIMIT,
    min_group_size: 3,
    speed_stdev_limit_mph: 1.3,
    spin_stdev_limit_rpm: 450,
    break_stdev_limit_ft: 0.5,
    training: true,
    check_confidence: true,
    check_spin: true,
    check_breaks: true,
  });
}
